<template>
	<header>
		<div class="fixing">
			<div class="container">
				<div class="logo">
					<a href="/">
						<img
							:src="require('@/assets/logo.png')"
							alt=""
							class="no_lazy">
					</a>
				</div>
				<div class="header_inner">
					<div class="borders">
						<div class="vert_borders" />
					</div>
					<div
						class="mobileMenu"
						:class="{ mobileMenuOpen }"
						@click="openMobileMenu">
						<div class="iconAnime">
							<span />
							<span />
							<span />
						</div>
					</div>
					<nav
						class="header_nav"
						@mouseleave="rocketEffectOff">
						<div class="menu-header-menu-container">
							<ul>
								<li
									v-for="(item, index) in menuHeader"
									:key="index"
									class="menu-item"
									:class="item.active ? 'current-menu-item' : ''">
									<a
										:href="item.url"
										:target="item.target"
										@mouseover="rocketEffect">
										{{ item.text }}
										<span
											v-if="item.active"
											class="underline" />
									</a>
								</li>
							</ul>
						</div>
						<ul class="header_social_links mobile_links" />
					</nav>
					<div class="header_btn">
						<span>
							<a
								class="button_ghost_basic"
								href="https://opensea.io/collection/bulldroids-nft"
								target="_blank">
								<img
									:src="require('@/assets/images/buy_button_text_web.png')"
									alt="">
							</a>
						</span>
					</div>
				</div>
			</div>
		</div>
		<ul class="header_social_links desktop_links">
			<li
				v-for="(item, index) in menuSocial"
				:key="index">
				<a
					:href="item.url"
					:target="item.target"
					class="header_social">
					<img
						:src="require(`@/assets/images/social/${item.img}`)"
						alt="">
				</a>
			</li>
		</ul>
	</header>
</template>

<script setup>
import { ref } from 'vue';

const menuSocial = [
	{
		url: 'https://opensea.io/collection/bulldroids-nft',
		img: 'opensea.svg',
		target: '_blank',
	},
	{
		url: 'https://rarity.tools/bulldroids-nft',
		img: 'r-t.png',
		target: '_blank',
	},
	{
		url: 'https://twitter.com/bulldroids',
		img: 'twitter-icon.svg',
		target: '_blank',
	},
	{
		url: 'https://discord.gg/7WDGEGRa25',
		img: 'Group-228.svg',
		target: '_blank',
	},
	{
		url: 'https://www.tiktok.com/@bulldroids_nft',
		img: 'Tiktok.svg',
		target: '_blank',
	},
	{
		url: 'https://www.instagram.com/bulldroids/',
		img: 'Instagram-1.svg',
		target: '_blank',
	},
	{
		url: 'https://www.facebook.com/bulldroids',
		img: 'facebook.svg',
		target: '_blank',
	},
	{
		url: 'https://well-wash-b25.notion.site/Bulldroids-White-Paper-fa8c02c2f1b14f9ba874db32bf0b67d7',
		img: 'notion-white.svg',
		target: '_blank',
	},
];

const menuHeader = [
	{
		url: 'https://bulldroids.com/',
		text: 'HOME',
		target: '',
	},
	{
		url: 'https://bulldroids.com/#factions',
		text: 'FACTION',
		target: '',
	},
	{
		url: 'https://bulldroids.com/#game',
		text: 'GAME',
		target: '',
	},
	{
		url: 'https://bulldroids.com/#rarity',
		text: 'RARITY',
		target: '',
	},
	{
		url: 'https://bulldroids.com/#roadmaps',
		text: 'ROADMAPS',
		target: '',
	},
	{
		url: 'https://bulldroids.com/#team',
		text: 'TEAM',
		target: '',
	},
	{
		url: 'https://bulldroids.com/#faq',
		text: 'Q&A',
		target: '',
	},
	{
		url: 'https://well-wash-b25.notion.site/Bulldroids-White-Paper-fa8c02c2f1b14f9ba874db32bf0b67d7',
		text: 'WHITE PAPER',
		target: '',
	},
	{
		url: '/',
		text: '',
		target: '',
		active: true,
	},
];

const mobileMenuOpen = ref(false);

const openMobileMenu = () => {
	mobileMenuOpen.value = !mobileMenuOpen.value;
	document.querySelector('.header_nav').style.display = mobileMenuOpen.value ? 'block' : 'none';
};

const rocketEffect = (e) => {
	if (window.innerWidth > 1199) {
		const { x: offset } = document.querySelector('nav li.current-menu-item > a').getBoundingClientRect();
		const { x: targetOffset } = e.target.getBoundingClientRect();
		const target = targetOffset - offset;
		const width = e.target.offsetWidth;
		document.querySelector('.underline').style.transform = `translateX(${target}px)`;
		document.querySelector('.underline').style.width = `${width}px`;
	}
};

const rocketEffectOff = () => {
	document.querySelector('.underline').style = '';
};
</script>
